import { reactive, toRefs, computed, provide, inject, isRef } from "@vue/composition-api";
import { clients_list, clients_visible } from "../../api";
import { getters as userGetters, actions as userActions } from "./user";
import Vue from "vue";
import axios from "axios";
import {uku_send_event, UKU_ACTIVITIES} from "@/helpers/uku_activity";
import router from "../../router";

export const state = reactive({
    clients: [],
    total: 0,
    latest_fetch_members: [],
    loading: false,
    current_client: null
});

export const actions = {

    fetch(params) {
        return new Promise(function (resolve, reject) {
            axios
                .get(`clients_list`, { params: params })
                .then((response) => {
                    state.clients = response.data.clients;
                    state.total = response.data.total;
                    resolve(response.data)
                }).catch((ex) => {
                    reject(ex);
                }).finally(() => {
                    state.loading = false;
                })
        })
    },
    async fetchVisibleClients() {
        let response;
        state.loadign = true;
        try {
            response = await clients_visible.get();
            state.clients = response.clients;
        } finally {
            state.loading = false;
        }
    },
    fetchClient(params) {
        return new Promise((resolve, reject) => {
            let req_params = {};
            if (params.include_default_person !== undefined && params.include_default_person) req_params.include_default_person = 1;
            if (params.include_contacts !== undefined && params.include_contacts) req_params.include_contacts = 1;
            if (params.include_emails !== undefined && params.include_emails) req_params.include_emails = 1;
            if (params.include_groups !== undefined && params.include_groups) req_params.include_groups = 1;
            if (params.for_edit !== undefined && params.for_edit) req_params.for_edit = 1;

            axios
                .get(Vue.config.url_prefix + "/api/clients/{0}".format(params.client_id), { params: req_params })
                .then(resp => {
                    state.latest_fetch_members = resp.data.members;
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },
    fetchClients(params) {
        return new Promise((resolve, reject) => {
            axios
                .get(Vue.config.url_prefix + "/api/clients_list", { params })
                .then(resp => {
                    // Update clients only if we return actual clients not sorted ids, sorted_ids should probably be moved to a separate method at one point
                    if (!params.as_sorted_ids) {
                        state.clients = resp.data.clients;
                        state.total = resp.data.total;
                    }

                    resolve(resp.data);
                })
                .catch(ex => { reject(ex) });
        })
    },
    executeClientsAction(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/clients/{0}".format(data.action), data)
                .then(function (resp) {

                    state.clients.forEach(client => {
                        return resp.data.clients.forEach(respClient => {
                            if (client.id === respClient.id) {
                                return client.default_person_name = respClient.default_person_name
                            }
                        })

                    });

                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                })
        })
    },
    saveClient(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/clients/0", data)
                .then(function (resp) {
                    resolve(resp.data)
                    // UKU-2600 :: todo metrics - read window
                    uku_send_event({event: UKU_ACTIVITIES.ADDED_CLIENT, info: "client.saveClient"})
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    deleteClient(data) {
        return new Promise(function (resolve, reject) {
            axios
                .delete(Vue.config.url_prefix + "/api/clients/{0}".format(data.client_id))
                .then(function () {
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    bulkClientsAction(params) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/clients/{0}".format(params.action), params)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    companyAutocomplete(params) {
        return new Promise(function (resolve, reject) {
            axios
                .get("/prospective_client/autosuggest", { params: params })
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    companyExtraInfo(params) {
        return new Promise(function (resolve, reject) {
            axios
                .get("/prospective_client/", { params: params })
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    searchClients(params) {
        let val = '';
        let queryArr = [];
        for (let key in params) {
            if (params[key] == null) {
                queryArr.push("{0}=".format(key));
            } else if (Object.prototype.hasOwnProperty.call(params, key)) {
                val = Array.isArray(params[key]) ? params[key].join(",") : params[key];
                if (key === "keyword") val = encodeURIComponent(val);
                queryArr.push("{0}={1}".format(key, val));
                // encodeURIComponent(Array.isArray(params[key]) ? params[key].join(",") : params[key])
            }
        }
        return new Promise(function (resolve, reject) {
            clients_list
                .get("?" + queryArr.join("&"))
                .then(function (resp) {
                    resolve(resp);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    setCurrentClient(client) {
        state.current_client = client;
    },
    clearCurrentClient() {
        state.current_client = null;
    },
    cpFetchUsers(client_id) {
        return new Promise((resolve, reject) => {
            axios
                .get(Vue.config.url_prefix + "/api/clients/{0}/cp_users/".format(client_id))
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },
    async fetchClientContacts(clientId) {
        return await axios.get(`/clients/${clientId}/contacts`)
    },
    navigateToClientEdit() {
        const client = state.current_client
        if (client.is_person) {
            router.push({name: "profile_edit", params: {accountId: client.account_id}})
        } else {
            router.push({name: "client_edit", params: {id: client.id}});
        }
    }
};

export const getters = {
    // clients: computed(() => state.list),
    getCurrentClient() {
        return state.current_client
    },
    getClient(client_id) {
        return state.clients.find(x => x.id === client_id);
    },
    getClientPersonsMap: client_obj =>
        computed(() => {
            const admin_users = userGetters.adminUsers;
            const client = isRef(client_obj) ? client_obj.value : client_obj;
            if (client && client.members) {
                //When Client object was loaded by clients/:id and has members but not security obj
                return new Map(
                    [...admin_users.value, ...client.members].map(member => {
                        return [
                            member.person_id,
                            {
                                ...member,
                                "full_name": member.name,
                                "id": member.id
                            }
                        ];
                    })
                );
            } else if (state.latest_fetch_members.length) {
                //When Client object was loaded by clients/:id but reactivity broke down and cant understand members
                return new Map(
                    state.latest_fetch_members.map(member => {
                        return [
                            member.person_id,
                            {
                                ...member,
                                "full_name": member.name,
                                "id": member.id
                            }
                        ];
                    })
                );
            } else {
                //Everything died
                return new Map();
            }
        }),
    expandClientMembers: function (showAllGroups = true) {
        if (state.current_client == null) return [];

        let id_list = state.current_client.members.map(x => x.id);
        let ret = [];
        let ret_id_list = [];
        let cur_members = userActions.getVisibleMembersByCompany(state.current_client.account_id);

        for (let i = 0; i < cur_members.length; i++) {
            let am = cur_members[i];
            if (!showAllGroups && id_list.indexOf(am.id) === -1) continue;
            else if (showAllGroups && id_list.indexOf(am.id) === -1 && am.type === "person") continue;

            if (am.type === "person" || am.type === "group") {
                if (ret_id_list.indexOf(am.id) >= 0) continue;
                ret.push(am);
                ret_id_list.push(am.id);
            }
        }

        ret.sort(function (a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
        return ret;
    },
};

export const key = Symbol("ClientModule");

export const provideClient = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
